import React from "react";
function Testimonials(){
    return(<>
    <div className="container-fluid bg-secondary mb-5">
            <div className="container py-3">
            <div class="d-flex justify-content-between ">
              <div className="fw-bold text-white  " >TESTIMONIALS</div>
              <div  className="fw-bold text-white ">Home > Testimonial</div>
                </div>
            </div>
         </div>

       <div className="container">
       <div className="row mb-5">
          <div className="about_title">
            <p className="fw-bold">Fruits Shop</p>
            <h3 className="fw-bold bg_text">Our Testimonials</h3>
            <div class="fancy-border"></div>
          </div>
        </div>
       </div>


     <div className="container mt-5 mb-5">    
     <div className="row">
     <iframe src='https://widgets.sociablekit.com/google-reviews/iframe/243169' frameborder='0' width='100%' height='1000'></iframe>
        </div>
     </div>
    </>);
}

export default Testimonials;